import { post } from 'utils/fetch';
import endpoints, { EEndpoints } from 'config/endpoints';
import { auth as typesAuth } from 'types';

const auth = {
    signIn: ({ email, password, code }: typesAuth.TSignInParams) => {
        return post<typesAuth.TSignInParams, typesAuth.TAuthResp>(
            `${endpoints[EEndpoints.signIn]()}`,
            {
                email,
                password,
                code,
            },
        );
    },
    logOut: () => {
        return post<null, null>(`${endpoints[EEndpoints.logOut]()}`, null);
    },
};

export default auth;
